/** Dispone eventi sovrapposti in colonne, come in un calendario a griglia oraria. */
export function layoutDayEvents(events) {
    const items = events
        .map((event) => {
            const start = new Date(event.start_datetime);
            const end = new Date(event.end_datetime);
            const startMs = start.getTime();
            const endMs = end.getTime();
            if (!Number.isFinite(startMs) || !Number.isFinite(endMs) || endMs <= startMs) return null;
            return { event, startMs, endMs, col: 0, cols: 1 };
        })
        .filter(Boolean)
        .sort((a, b) => a.startMs - b.startMs || b.endMs - a.endMs);

    const columnEnds = [];
    items.forEach((item) => {
        let col = columnEnds.findIndex((end) => end <= item.startMs);
        if (col === -1) {
            col = columnEnds.length;
            columnEnds.push(item.endMs);
        } else {
            columnEnds[col] = item.endMs;
        }
        item.col = col;
    });

    const parent = items.map((_, i) => i);
    const find = (i) => {
        if (parent[i] !== i) parent[i] = find(parent[i]);
        return parent[i];
    };
    const unite = (a, b) => {
        const pa = find(a);
        const pb = find(b);
        if (pa !== pb) parent[pb] = pa;
    };
    for (let i = 0; i < items.length; i += 1) {
        for (let j = i + 1; j < items.length; j += 1) {
            if (items[j].startMs >= items[i].endMs) break;
            if (items[i].startMs < items[j].endMs && items[j].startMs < items[i].endMs) {
                unite(i, j);
            }
        }
    }
    const maxCol = {};
    items.forEach((item, i) => {
        const root = find(i);
        maxCol[root] = Math.max(maxCol[root] || 0, item.col + 1);
    });
    items.forEach((item, i) => {
        item.cols = maxCol[find(i)] || 1;
    });

    return items;
}

export function eventsForLocalDay(events, date) {
    const dateStr = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
    return events.filter((event) => {
        const start = new Date(event.start_datetime);
        if (Number.isNaN(start.getTime())) return false;
        const eventDay = `${start.getFullYear()}-${String(start.getMonth() + 1).padStart(2, '0')}-${String(start.getDate()).padStart(2, '0')}`;
        return eventDay === dateStr;
    });
}
